import { ref as i, onActivated as r } from "vue";
let d;
const p = new Uint8Array(16);
function m() {
  if (!d && (d = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !d))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return d(p);
}
const u = [];
for (let n = 0; n < 256; ++n)
  u.push((n + 256).toString(16).slice(1));
function y(n, t = 0) {
  return u[n[t + 0]] + u[n[t + 1]] + u[n[t + 2]] + u[n[t + 3]] + "-" + u[n[t + 4]] + u[n[t + 5]] + "-" + u[n[t + 6]] + u[n[t + 7]] + "-" + u[n[t + 8]] + u[n[t + 9]] + "-" + u[n[t + 10]] + u[n[t + 11]] + u[n[t + 12]] + u[n[t + 13]] + u[n[t + 14]] + u[n[t + 15]];
}
const U = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), o = {
  randomUUID: U
};
function c(n, t, g) {
  if (o.randomUUID && !n)
    return o.randomUUID();
  n = n || {};
  const e = n.random || (n.rng || m)();
  return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, y(e);
}
const a = () => {
  const n = i(c());
  return r(() => {
    n.value = c();
  }), { uuidValue: n };
};
export {
  a as u
};
//# sourceMappingURL=useUuid-BHJNgR58.js.map
